export const isValidURL = url => {
  try {
    return Boolean(new URL(url))
  } catch (err) {
    return false
  }
}

export const isValidJSON = string => {
  try {
    JSON.parse(string)
    return true
  } catch (e) {
    return false
  }
}

export const SPECIAL_CHARACTERS = ['<', '>', '*', '%', '&', '\\', ':', '$']
const specialCharactersRegexp = new RegExp(`[${SPECIAL_CHARACTERS.join('')}]`, 'g')
export const containsSpecialCharacters = (value) => specialCharactersRegexp.test(value)
